module.exports = __webpack_public_path__ + "img/competitions.8cf8f1c8.png";